import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useField } from "react-final-form";
import useEditedStyles from "../hooks/useEditedStyles";

export const FirmwareLinkField = () => {
  const [link, setLink] = useState<string | null>(null);

  const {
    input: repositoryInput,
    meta: { dirty: repositoryDirty = false },
  } = useField<string | null>("repository", { allowNull: true });
  const {
    input: commitInput,
    meta: { dirty: commitDirty = false },
  } = useField<string | null>("commit", { allowNull: true });

  const { formatMessage } = useIntl();
  const editedStyle = useEditedStyles();

  const openLink = useCallback(() => {
    if (!link) {
      return;
    }
    window.open(link, "_blank", "noopener,noreferrer");
  }, [link]);

  const handleLinkChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const linkValue = e.target.value;
      setLink(linkValue);
      if (!linkValue.startsWith("https://bitbucket.org/mohanet/")) {
        console.warn("Invalid link:", linkValue);
        return;
      }
      const [repository, type, commit] = linkValue.substring("https://bitbucket.org/mohanet/".length).split("/");
      if (type !== "commits") {
        console.warn("Invalid link:", linkValue);
        return;
      }
      repositoryInput.onChange(repository);
      commitInput.onChange(commit);
    },
    [commitInput, repositoryInput]
  );

  useEffect(() => {
    if (!repositoryInput.value || !commitInput.value) {
      setLink("");
      return;
    }
    setLink(`https://bitbucket.org/mohanet/${repositoryInput.value}/commits/${commitInput.value}`);
  }, [repositoryInput.value, commitInput.value]);

  return (
    <TextField
      value={link ?? ""}
      className={repositoryDirty || commitDirty ? editedStyle.input : ""}
      onChange={handleLinkChange}
      label={formatMessage({ defaultMessage: "Link" })}
      variant="filled"
      size="small"
      fullWidth
      sx={{ m: 0 }}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        endAdornment: link ? (
          <InputAdornment position="end">
            <IconButton onClick={openLink} edge="end" sx={{ ml: 1 }}>
              <OpenInNewIcon width={24} height={24} color="secondary" />
            </IconButton>
          </InputAdornment>
        ) : undefined,
      }}
      onFocus={(e) => e.target.select}
    />
  );
};
